const ACKNOWLEDGE_CANCELLATION = "ACKNOWLEDGE_CANCELLATION";
const ACKNOWLEDGE_CANCELLATION_SUCCESS = "ACKNOWLEDGE_CANCELLATION_SUCCESS";
const ACKNOWLEDGE_CANCELLATION_FAILURE = "ACKNOWLEDGE_CANCELLATION_FAILURE";
const CLEAR_ACKNOWLEDGE_CANCELLATION = "CLEAR_ACKNOWLEDGE_CANCELLATION";

const AcknowledgeCancellation = {
  ACKNOWLEDGE_CANCELLATION_SUCCESS,
  ACKNOWLEDGE_CANCELLATION_FAILURE,
  ACKNOWLEDGE_CANCELLATION,
  CLEAR_ACKNOWLEDGE_CANCELLATION,
};
export default AcknowledgeCancellation;
